import React from "react";
import { CloseOutlined } from "@ant-design/icons";

const PURPLE = "#6528d8";

export function CrossTabFilterTag({ label, value, onClose }) {
    return (
        <div
            style={{
                position: "relative",
                display: "inline-block",
                backgroundColor: PURPLE,
                color: "#ffffff",
                borderRadius: "8px",
                padding: "10px 40px 10px 14px",
                marginBottom: "16px",
                lineHeight: 1.4,
            }}
        >
            <span
                style={{
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontSize: "16px",
                    letterSpacing: "0.03em",
                }}
            >
                {label}
            </span>
            <span style={{ margin: "0 6px", opacity: 0.9 }}>:</span>
            <span
                style={{
                    fontSize: "14px",
                    textTransform:
                        value === "NA" || value === "ON" ? "none" : "lowercase",
                    fontWeight: 400,
                }}
            >
                {value}
            </span>
            <button
                type="button"
                onClick={onClose}
                aria-label={`Remove ${label} filter`}
                style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    color: PURPLE,
                    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.12)",
                }}
            >
                <CloseOutlined style={{ fontSize: "14px", fontWeight: 700 }} />
            </button>
        </div>
    );
}
